import { useEffect, useState } from "react";
import confetti from "canvas-confetti";

export default function CompletionScreen({ lesson, xp, onClose, onContinue, isLastLesson }) {
  const [displayXp, setDisplayXp] = useState(0);

  useEffect(() => {
    // Confetti burst
    const fire = (particleRatio, opts) => {
      confetti({
        origin: { y: 0.7 },
        ...opts,
        particleCount: Math.floor(180 * particleRatio),
        colors: ["#f5c87a", "#d39f3f", "#8b6df0", "#5fd5a6", "#ffffff"],
      });
    };
    fire(0.25, { spread: 26, startVelocity: 55 });
    fire(0.2, { spread: 60 });
    fire(0.35, { spread: 100, decay: 0.91, scalar: 0.9 });
    fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
    fire(0.1, { spread: 120, startVelocity: 45 });

    // Count up XP
    let raf;
    const start = performance.now();
    const duration = 1100;
    const animate = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplayXp(Math.round(eased * xp));
      if (t < 1) raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, [xp]);

  return (
    <div className="completion" data-testid="completion-screen">
      <div className="completion-card">
        <div className="big-badge" data-testid="completion-badge">
          {lesson.badge.icon}
        </div>
        <div className="muted" style={{ fontSize: 14 }}>
          شارة جديدة
        </div>
        <h2 data-testid="badge-name">{lesson.badge.name}</h2>
        <p>أحسنتَ! أكملتَ درس «{lesson.title}» بنجاح. خطوة جميلة في رحلتك البلاغية.</p>
        <div className="xp-burst" data-testid="xp-burst">+{displayXp} XP</div>
        <div className="completion-actions">
          <button
            data-testid="completion-continue-btn"
            className="btn btn-primary"
            onClick={onContinue}
          >
            {isLastLesson ? "العودة إلى الدروس" : "الدرس التالي ←"}
          </button>
          <button
            data-testid="completion-close-btn"
            className="btn btn-ghost"
            onClick={onClose}
          >
            إغلاق
          </button>
        </div>
      </div>
    </div>
  );
}
